module.exports = __webpack_public_path__ + "static/img/league_building_03.3a53aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/league_building_03.png
// module id = EENL
// module chunks = 0